module.exports = __webpack_public_path__ + "static/media/money-bill.41037096.svg";